module.exports = __webpack_public_path__ + "img/denim_wash_shirt.54e2d12f.jpg";